module.exports = __webpack_public_path__ + "img/output-image.4d87367d.svg";